import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import styles from "../Styles/Modals.module.css";

const style = {
  position: "absolute",
  top: "40%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50%",
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: "20px",
  p: 4,
};

function Org_details({ open, handleOpen, handleClose, data }) {
  const storage = window.sessionStorage;
  const profile = JSON.parse(storage.getItem("profile"));

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Organization Details
              </h1>
              {/* <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={handleClose}
              ></button> */}
            </div>
            <div className="modal-body mt-4" id={styles.desc_modal}>
                 <p><span>Company Name</span> : {data[0]?.company_name}</p>
                 <div id={styles.location_contain}>
                  <p><span>Country</span> : {data[0]?.country_name}</p>
                  <p><span>State</span> : {data[0]?.state_name}</p>
                  <p><span>City</span> : {data[0]?.city_name}</p>
                 </div>
                 <p><span>Address</span> : {data[0]?.address}</p>
                   <p><span>Zip Code</span> : {data[0]?.zipcode}</p>
                   <p><span>Contact Person</span> : {data[0]?.contact_person_1}</p>
            </div>
            <div className="modal-footer mt-2">
              <button
                type="button"
                className="btn btn-secondary"
                // data-bs-dismiss="modal"
                onClick={handleClose}
              >
                Close
              </button>
            </div>
          </div>
        </Box>
      </Modal>
    </>
  );
}

export default Org_details;
